import React, { useEffect, useState } from "react";
import MobileBreadcrum from "./MobileBreadcrum";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import MobileImgSlider from "./MobileImgSlider";
import MobileBasicDetail from "./MobileBasicDetail";
import MobilePrice from "./MobilePrice";
import MobileAdvantage from "./MobileAdvantage";
import MobileVarientSelection from "./MobileVarientSelection";
import MobilePriceBreakDown from "./MobilePriceBreakDown";
import MobileDescPromises from "./MobileDescPromises";
import MobileProductTabs from "./MobileProductTabs";
import { useParams } from "react-router";
import {
  fetchDealerProductDetailsAsync,
  fetchProductDetailsAsync,
  selectProductDetails,
  setSelectedProd_ID,
  setSelectedVariant,
} from "../../features/productDesc/productDescSlice";
import { useDispatch, useSelector } from "react-redux";
import ImportantKeys from "../../components/ProductDescription/ImportantKeys";
import SwipeToAction from "./SwipeToAction";
import AddToCartButton from "./AddToCartButton";

function MobileDetails() {
  const { prod_ID } = useParams();
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const selectedVariant = useSelector(
    (state) => state.productDetail.selectedVariant
  );

  const dispatch = useDispatch();
  const productSelect = useSelector(selectProductDetails);

  useEffect(() => {
    const fetchData = async () => {
      handleOpen();
      await dispatch(setSelectedProd_ID(prod_ID));
      if (prod_ID?.startsWith("9")) {
        await dispatch(fetchDealerProductDetailsAsync(prod_ID));
      } else {
        await dispatch(fetchProductDetailsAsync(prod_ID));
      }
      handleClose();
    };
    fetchData();
    return () => clearTimeout(2000);
  }, [dispatch, prod_ID]);

  useEffect(() => {
    if (
      productSelect?.products?.length > 0 &&
      productSelect.products[0]?.skuDetails?.length > 0 &&
      selectedVariant?.length === 0
    ) {
      dispatch(setSelectedVariant(productSelect.products[0].skuDetails[0]));
    }
  }, [dispatch, productSelect]);

  return (
    <div className="w-screen flex flex-col items-start justify-start bg-white-1">
      {/* Loader */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Breadcrumb */}
      <div className="w-full">
        <MobileBreadcrum />
      </div>

      {/* Image Slider */}
      <div className="w-full">
        <MobileImgSlider selectProduct={productSelect.products} />
      </div>

      {/* Basic Details */}
      <div className="w-full">
        <MobileBasicDetail selectProduct={productSelect.products} />
        {productSelect?.products?.length > 0 &&
          productSelect.products[0]?.Manufacturer === "GARRARI BIKES" && (
            <ImportantKeys selectProduct={productSelect.products} />
          )}
      </div>

      {/* Product Advantages */}
      <div className="w-full">
        <MobileAdvantage selectProduct={productSelect.products} />
      </div>

      {/* Price Section */}
      <div className="w-full">
        <MobilePrice selectProduct={productSelect.products} />
      </div>

      {/* Variant Selection */}
      {/* <div className="w-full">
        <MobileVarientSelection
          selectProduct={productSelect.products}
          qtys={productSelect?.quantity}
        />
      </div> */}

      {/* Price Breakdown */}
      <div className="w-full">
        <MobilePriceBreakDown
          currentProduct={productSelect.products}
        />
      </div>

      {/* Promises Section */}
      <div className="w-full">
        <MobileDescPromises selectProduct={productSelect.products} />
      </div>

      {/* Product Tabs */}
      <div className="w-full">
        <MobileProductTabs productDesc={productSelect.products} />
      </div>
      {/* <SwipeToAction selectProduct={productSelect.products}
        qtys={productSelect?.quantity} /> */}

      <AddToCartButton selectProduct={productSelect.products}
        qtys={productSelect?.quantity} />

    </div>
  );
}

export default MobileDetails;
